const prefix = ''

export type TAccountTabs = 'info' | 'password' | ':tabValue'

export const accountUrls = {
  account: (tab: TAccountTabs = ':tabValue') => `${prefix}/account/${tab}`,
}
